import { useEffect, useContext, useState } from "react";

import { activateTrial, getBillingRedirect } from "../../../api";
import
{

  BannerContainer,
  CaptionContainer,
  CaptionText,
} from "./Licences.styles";
import { licenceTypes, licenceOptions } from "../../../options/licenceOptions";
import MainWrapper from "../../../components/Wrappers/MainWrapper/MainWrapper";
import Title from "../../../components/Typography/Title/Title";
import Banner from "../../../components/Alerts/Banner/Banner";
import StandardModal from "../../../components/Modals/StandardModal/StandardModal";
import SubscriptionNonPaymentForm from "../../../components/Forms/SubscriptionNonPaymentForm/SubscriptionNonPaymentForm";
import SubscriptionPaymentForm from "../../../components/Forms/SubscriptionPaymentForm/SubscriptionPaymentForm";
import StandardLink from "../../../components/Links/StandardLink/StandardLink";

// Contexts
import { BaseContext } from "../../../providers/Global/BaseProvider";
// import { LicencesContext } from "../../../providers/Index/LicencesProvider";
import SubscriptionCard from "../../../components/Cards/SubscriptionCard/SubscriptionCard";
import { routes } from "../../../options/routes";
import { Button, Stack, Typography, useMediaQuery } from "@mui/material";
import Index1Link from "../../../components/Links/Index1Link/Index1Link";
import { getManageClubId } from "../../../utils/helpers/clubHelper";

// API Calls

const Licences = () =>
{
  // Collapse accordions when matches value changes
  const baseContext = useContext(BaseContext);
  // const licencesContext = useContext(LicencesContext);
  const [dataLoading, setDataLoading] = useState(true);
  const [licenceDetails, setLicenceDetails] = useState([]);
  const [activeLicences, setActiveLicences] = useState([]);
  const [selectedLicence, setSelectedLicence] = useState("");
  const [activeLicenceExpiry, setActiveLicenceExpiry] = useState(null);
  const [nonPaymentModalOpen, setNonPaymentModalOpen] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [bannerError] = useState("");
  const [error, setError] = useState({
    show: false,
    message: "",
  });

  const isWide = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  useEffect(() =>
  {
    if (
      !baseContext.baseData.loading
    )
    {
      setDataLoading(false);
      // setLicenceDetails(
      //   licencesContext.licencesData.licences.length > 0
      //     ? licenceOptions.filter((licence) => licence.id !== 1)
      //     : licenceOptions
      // );
      setLicenceDetails(licenceOptions)
      const date = new Date();
      setActiveLicenceExpiry(new Date(date.setDate(date.getDate() + 30)));
      setActiveLicences(baseContext.baseData.licences);
    }
  }, [baseContext]);

  const handleBannerClose = () =>
  {
    setError({
      show: false,
      message: "",
    });
  };

  const handleLicenceClick = async (type, freq, setRedirectLoading) =>
  {
    let response;
    let params = {
      success_url: document.location.href + "/success",
      cancel_url: document.location.href + "/error",
    };
    let clubId = await getManageClubId();
    if (clubId)
    {
      params['club_id'] = clubId;
    }
    switch (type)
    {
      case licenceTypes.nonCommercial:
        setSelectedLicence(type);
        setNonPaymentModalOpen(true);
        break;
      case licenceTypes.trial:
        setSelectedLicence(type);
        setNonPaymentModalOpen(true);
        break;
      case licenceTypes.clubSub:
        setSelectedLicence(type);
        params.subscription = (freq === "monthly") ? "index_club_month" : "index_club_year";
        params.success_url += "?success=" + params.subscription;
        response = await getBillingRedirect(params);
        document.location = response.data.url;
        break;
      case licenceTypes.personalSub:
        setSelectedLicence(type);
        params.subscription = (freq === "monthly") ? "index_personal_month" : "index_personal_year";
        params.success_url += "?success=" + params.subscription;
        response = await getBillingRedirect(params);
        document.location = response.data.url;
        break;
      default:
        setError({
          show: true,
          message: "Please choose a valid subscription type",
        });
    }
  };

  const handleNonPaymentModalClose = () =>
  {
    setNonPaymentModalOpen(false);
    setSelectedLicence("");
  };

  const handleNonPaymentModalSubmit = async () =>
  {
    await setModalLoading(true);
    let response = await activateTrial({});
    setError({
      show: false,
      message: `Successfully activated ${selectedLicence} Subscription`,
    });
    setModalLoading(false);
    handleNonPaymentModalClose();
    window.location.href = `${routes.home}`;
  };

  const handlePaymentModalClose = () =>
  {
    setPaymentModalOpen(false);
    setSelectedLicence("");
  };

  return (
    <>
      {
        <MainWrapper
          error={error.show}
          apiMessage={error.message}
          handleBannerClose={handleBannerClose}
          activeRoute={routes.indexLicences}
          clubLogo={baseContext.baseData.clubProfile.logo}
          dataLoading={dataLoading}
          hasEliteLicence={baseContext.baseData.hasEliteLicence}
          hasRezzilPlayerLicence={baseContext.baseData.hasRezzilPlayerLicence}
          licences={baseContext.baseData.licences}
        >
          <Title text={"Licences"} />
          {bannerError && (
            <BannerContainer>
              <Banner open={bannerError} text={bannerError} />
            </BannerContainer>
          )}
          {licenceDetails.length &&
            <Stack direction={isWide ? "row" : "column"} justifyContent="center" alignItems="center" spacing={4}>
              <SubscriptionCard
                key="noncommercial_card"
                avatarBgColor={licenceDetails[0].avatarBgColor}
                icon={licenceDetails[0].icon}
                title={licenceDetails[0].title}
                features={licenceDetails[0].features}
                isRecommended={false}
                isTrial={false}
                isEnabled={false}
                onClick={(freq) => handleLicenceClick(licenceDetails[0].title, freq)}
                isExpired={false}
                isActive={!baseContext.baseData.hasEliteClubLicence && !baseContext.baseData.hasElitePersonalLicence}
                showDowngrade={false}
                showUpgrade={false}
              />
              {!baseContext.baseData.hasEliteClubLicence && !baseContext.baseData.hasElitePersonalLicence &&
                !baseContext.baseData.hasExpiredEliteClubLicence && !baseContext.baseData.hasExpiredElitePersonalLicence &&
                <SubscriptionCard
                  key="trial_card"
                  avatarBgColor={licenceDetails[1].avatarBgColor}
                  icon={licenceDetails[1].icon}
                  title={licenceDetails[1].title}
                  features={licenceDetails[1].features}
                  isRecommended={false}
                  isTrial={true}
                  isEnabled={true}
                  onClick={(freq) => handleLicenceClick(licenceDetails[1].title, freq)}
                  isExpired={false}
                  isActive={baseContext.baseData.hasTrialLicence}
                  showDowngrade={false}
                  showUpgrade={false}
                />
              }
              <SubscriptionCard
                key="index_personal_card"
                avatarBgColor={licenceDetails[2].avatarBgColor}
                icon={licenceDetails[2].icon}
                title={licenceDetails[2].title}
                features={licenceDetails[2].features}
                isRecommended={false}
                isTrial={false}
                isEnabled={!baseContext.baseData.hasEliteClubLicence}
                willRedirect={true}
                onClick={(freq) => handleLicenceClick(licenceDetails[2].title, freq)}
                isExpired={!baseContext.baseData.hasEliteClubLicence && !baseContext.baseData.hasElitePersonalLicence && baseContext.baseData.hasExpiredElitePersonalLicence}
                isActive={baseContext.baseData.hasElitePersonalLicence}
                showDowngrade={false}
                showUpgrade={!baseContext.baseData.hasEliteClubLicence && !baseContext.baseData.hasElitePersonalLicence}
              />
              <SubscriptionCard
                key="index_club_card"
                avatarBgColor={licenceDetails[3].avatarBgColor}
                icon={licenceDetails[3].icon}
                title={licenceDetails[3].title}
                features={licenceDetails[3].features}
                isRecommended={true}
                isTrial={false}
                isEnabled={true}
                willRedirect={true}
                onClick={(freq) => handleLicenceClick(licenceDetails[3].title, freq)}
                isExpired={!baseContext.baseData.hasEliteClubLicence && !baseContext.baseData.hasElitePersonalLicence && baseContext.baseData.hasExpiredEliteClubLicence}
                isActive={baseContext.baseData.hasEliteClubLicence}
                showDowngrade={false}
                showUpgrade={!baseContext.baseData.hasEliteClubLicence && !baseContext.baseData.hasElitePersonalLicence || baseContext.baseData.hasElitePersonalLicence}
              />
            </Stack>
          }
          <Stack direction="row" alignContent="center" justifyContent="center">
            <Stack direction="column" sx={{ maxWidth: "30em", marginTop: "2em" }}>
              <Typography sx={{ textAlign: "center" }}>Download the latest Rezzil Index software</Typography>
              <Button onClick={() => { window.open("https://rezzil.com/rezzil-installer", "_blank"); }}>
                Download
              </Button>
            </Stack>
          </Stack>
          <CaptionContainer>
            <CaptionText>
              For more info on Rezzil Index please visit
            </CaptionText>
            <StandardLink
              text={"rezzil.com"}
              href={"https://rezzil.com/"}
              isMailto
            />
          </CaptionContainer>
          {nonPaymentModalOpen && (
            <StandardModal
              open={nonPaymentModalOpen}
              onClose={handleNonPaymentModalClose}
              title={`${selectedLicence} Subscription`}
              btnText={"Cancel"}
              hideCancelBtn
            >
              <SubscriptionNonPaymentForm
                expiryDate={
                  selectedLicence === licenceTypes.trial
                    ? activeLicenceExpiry
                    : null
                }
                licence={licenceDetails.find(
                  (licence) => licence.title === selectedLicence
                )}
                loading={modalLoading}
                handleSubmit={handleNonPaymentModalSubmit}
              />
            </StandardModal>
          )}
          {paymentModalOpen && (
            <StandardModal
              open={paymentModalOpen}
              onClose={handlePaymentModalClose}
              title={`${selectedLicence} Subscription`}
              btnText={"Cancel"}
              hideCancelBtn
            >
              <SubscriptionPaymentForm
                licence={licenceDetails.find(
                  (licence) => licence.title === selectedLicence
                )}
              />
            </StandardModal>
          )}
          <Index1Link />
        </MainWrapper>
      }
    </>
  );
};

export default Licences;
